<section class="section py-6">
    <div class="columns">
      <div class="column header-title-page">
        <h2 class="title-header">Usuarios</h2>
        <button class="button is-primary" (click)="openModal()">Nuevo usuario</button>
      </div>
    </div>
  </section>
  @if (isLoading) {
    <section class="section py-1">
      <app-spinner></app-spinner>
    </section>
  }
  @if (!isLoading) {
    <section class="section py-1">
      <div class="columns has-background-white">
        <div class="column">
          <div class="columns">
            <div class="column p-5">
              @if (users) {
                <div class="table-users">
                  <app-generic-table [columnsHeader]="COLUMNS_HEADER" [dataTable]="users"
                    (onSelectRow)="openModal($event)"></app-generic-table>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </section>
  }
  <div class="modal" [ngClass]="{'is-active': isModalActive }">
    <div class="modal-background"></div>
    <div class="modal-card">
      <form [formGroup]="form" (ngSubmit)="onSave()">
        <header class="modal-card-head">
          @if (isCreating) {
            <p class="modal-card-title">Nuevo usuario</p>
          }@else {
            <p class="modal-card-title">Usuario: {{ form.value.name }}</p>
          }
          <button type="button" class="delete" aria-label="close" (click)="closeModal()"></button>
        </header>
        <section class="modal-card-body">
          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label">Nombre</label>
                <div class="control">
                  <input class="input" type="text" placeholder="Nombre" formControlName="name">
                </div>
              </div>
              <div class="field">
                <label class="label">Usuario</label>
                <div class="control">
                  <input class="input" type="text" placeholder="Usuario" formControlName="username">
                </div>
              </div>
              <div class="field">
                <label class="label">Email</label>
                <div class="control">
                  <input class="input" type="text" placeholder="Email" formControlName="email">
                </div>
              </div>
              <div class="field">
                <label class="label">Rol</label>
                <div class="control">
                  <div class="tags">
                    @for(role of USER_ROLES; track role.key) {
                      <span class="tag mt-2" type="button" [ngClass]="{'is-primary': rolesSelected.includes(role.key) }" (click)="selectRole(role.key)">
                        {{ role.value }}
                      </span>
                    }
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot is-justify-content-space-between">
          <button type="button" class="button" (click)="closeModal()">Cancelar</button>
          <button type="submit" class="button is-primary" [disabled]="!form.valid">
            @if(isLoading) {
              <fa-icon [icon]="faSpinner"></fa-icon>
            } @else {
              <span>Guardar</span>
            }
          </button>
        </footer>
      </form>
    </div>
  </div>